import * as d3 from "d3";
import { useEffect } from "react";
import { parseSvg } from "d3-interpolate/src/transform/parse";

// const Order = ({ y, orders, height, effect, ordersCallback }) => {
const Order = ({ y_range, orders, height, effect, ordersCallback }) => {

    // var localOrders = [...Array(orders.length).keys().toString()]
    // const y = d3
    //     .scaleBand()
    //     .domain(orders)
    //     .range([0, y_range])
    //     .padding(0.1);

    // const y = d3
    //     .scaleBand()
    //     .domain(localOrders)
    //     .range([0, y_range])
    //     .padding(0.1);

    useEffect(() => {
        // var localOrders = [...Array(orders.length).keys()]
        // const y = d3
        //     .scaleBand()
        //     .domain(localOrders)
        //     .range([0, y_range])
        //     .padding(0.1);

        const y = d3
            .scaleBand()
            .domain(orders)
            .range([0, y_range])
            .padding(0.1);
        // console.log(localOrders)
        // console.log(orders)

        var dragging = {};
        var trigger;
        var translateX;
        const drag = d3
            .drag()
            .subject(function (event) {
                const me = d3.select(this);
                translateX = parseSvg(me.attr("transform"))["translateX"];
                return { y: me.attr("y") };
            })
            .on("start", function (event, track) {
                trigger = event.sourceEvent.target.className.baseVal;

                if (trigger === "fa burgers") {
                    dragging[track["order"]] = y(track["order"]);
                    d3.select(this).raise();
                }
            })
            .on("drag", function (event, track) {
                // console.log(orders)
                if (trigger === "fa burgers") {
                    // console.log(orders)

                    // console.log(height,event.y)

                    dragging[track["order"]] = Math.min(
                        height,
                        Math.max(0, event.y)
                    );

                    dragging[track["order"]] =
                        Math.max(0, event.y);

                    // console.log(dragging[track["order"]])


                    // key: sort by displacement
                    orders.sort(function (a, b) {
                        return position(a) - position(b);
                    });

                    // console.log(orders)
                    y.domain(orders);


                    // // key: sort by displacement
                    // localOrders.sort(function (a, b) {
                    //     return position(a) - position(b);
                    // });
                    //
                    // // console.log(orders)
                    // y.domain(localOrders);

                    d3.selectAll(".tracks").attr("transform", function (track) {
                        return (
                            "translate(" +
                            translateX +
                            "," +
                            position(track["order"]) +
                            ")"
                        );
                    });

                    d3.selectAll(".tracks").attr("y", function (track) {
                        return y(track["order"]);
                    });
                }
                else if(trigger === "fa leftRightMoveLabels"){
                    // console.log(event.x)

                    let boxWidth = d3.select('.boxes').attr('width')

                    d3.selectAll('.labels')
                        .attr('transform',function (track){
                            return (
                                "translate(" +
                                (event.x-translateX-boxWidth+10)+
                                "," +
                                0 +
                                ")"
                            );
                        })
                }
            })
            .on("end", function (event, track) {

                if (trigger === "fa burgers") {
                    // ordersCallback(localOrders);
                    ordersCallback(orders);
                    delete dragging[track["order"]];
                    transition(d3.select(this)).attr(
                        "transform",
                        "translate(" +
                            translateX +
                            "," +
                            y(track["order"]) +
                            ")"
                    );
                }
            });

        d3.selection.prototype.moveToFront = function () {
            return this.each(function () {
                this.parentNode.appendChild(this);
            });
        };

        function position(d) {
            var v = dragging[d];
            return v == null ? y(d) : v;
        }

        function transition(g) {
            return g.transition().duration(500);
        }

        d3.selectAll(".tracks").call(drag);
    }, [effect]);
};

export default Order;
